import React from "react";
import Rating from '@mui/material/Rating';
import { useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function ChefCard(props) {
  let navigate = useNavigate();

  function navigateToDetail(chef_id) {
    localStorage.setItem("chef_id", chef_id);
    navigate("/browse-chef", {
      state: {
        option: props?.option ?? null,
      },
    });
  }

  return (
    <div className="col-md-4 my-3 d-flex justify-content-center">
      <div
        className="card prof"
        style={{
          maxWidth: "350px",
          borderRadius: "20px",
          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
          border: "none",
        }}
      >
        {/* Owl Carousel with fixed height for consistent images */}
        <OwlCarousel
          items={1}
          center={true}
          mouseDrag={true}
          touchDrag={true}
          autoplay={true}
          autoplayHoverPause={true}
          dotsEach={true}
          className="owl-theme"
          loop
        >
          {/* Main chef image */}
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "250px", overflow: "hidden" }}
          >
            <img
              src={props.data.chef_profile_image}
              className="card-img-top"
              alt="..."
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={() => navigateToDetail(props.data.chef_id)}
            />
          </div>

          {/* Additional chef images */}
          {props.data.chef_images?.map((element, index) => (
            <div
              className="d-flex justify-content-center align-items-center"
              key={index}
              style={{ height: "250px", overflow: "hidden" }}
            >
              <img
                src={element}
                className="card-img-top"
                alt="..."
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </OwlCarousel>

        <div
          className="card-body py-4 pb-0"
          onClick={() => navigateToDetail(props.data.chef_id)}
          style={{ cursor: "pointer" }}
        >
          {/* Row: Name and Rating */}
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="fw-bolder" style={{ fontSize: "1rem" }}>
              {props.data.chef_name}
            </h6>
            <Rating
              name="half-rating-read"
              defaultValue={Number(props.data.chef_rating)}
              precision={0.5}
              readOnly
            />
          </div>

          {/*  Booking counts – stacked vertically, each with new icon */}
          <div className="mt-3">
          

            {/* Booking line */}
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              {/* New Booking icon: Calendar check */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#b4b1b1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-calendar-check"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="m9 16 2 2 4-4" />
              </svg>
              <span style={{ fontSize: "0.9rem" ,FontWeight: "bold" }}>
                <span style={{ fontWeight: "bold" }}>Orders:</span> {props.data.booking_count}
              </span>
            </div>
          </div>

          {/* Optional description (commented out) */}
          {/* <p className="mt-2" style={{ fontSize: "0.9rem" }}>{props.data.chef_description}</p> */}
        </div>
      </div>
    </div>
  );
}

export default ChefCard;